// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

.feedback-section {
  padding: 1rem;
  background: #f8fafc;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* Header */
  /* Table */
  /* Pagination Controls */
  /* Dialog Content */
}
.feedback-section .feedback-container {
  width: 100%;
  background: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.feedback-section .feedback-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}
.feedback-section .feedback-header .header-content {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.feedback-section .feedback-header .header-content .feedback-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}
.feedback-section .feedback-header .header-content .feedback-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}
.feedback-section .feedback-header .feedback-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
}
.feedback-section .feedback-header .search-box {
  display: flex;
  align-items: center;
  position: relative;
}
.feedback-section .feedback-header .search-box .icon {
  position: absolute;
  left: 10px;
  color: #9ca3af;
}
.feedback-section .feedback-header .search-box .search-input {
  width: 300px;
  padding: 0.6rem 0.8rem 0.6rem 2rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  outline: none;
  transition: all 0.2s ease-in-out;
}
.feedback-section .feedback-header .search-box .search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}
.feedback-section .feedback-card {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 70vh;
  border-radius: 0 0 1rem 1rem;
  /* Custom Scrollbar */
}
.feedback-section .feedback-card::-webkit-scrollbar {
  width: 6px;
  height: 8px;
}
.feedback-section .feedback-card::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.feedback-section .feedback-card::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.feedback-section .feedback-card::-webkit-scrollbar-track {
  background: transparent;
}
.feedback-section .feedback-card .feedback-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  color: #374151;
}
.feedback-section .feedback-card .feedback-table th,
.feedback-section .feedback-card .feedback-table td {
  padding: 0.9rem 1rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
  vertical-align: top;
}
.feedback-section .feedback-card .feedback-table th {
  background: #f3f4f6;
  color: #111827;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}
.feedback-section .feedback-card .feedback-table th .th-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.feedback-section .feedback-card .feedback-table th .th-content i {
  font-size: 0.9rem;
  color: #6b7280;
}
.feedback-section .feedback-card .feedback-table tr:hover {
  background: #f9fafb;
}
.feedback-section .feedback-card .feedback-table .question-cell {
  width: 20%;
  font-weight: 500;
}
.feedback-section .feedback-card .feedback-table .answer-cell {
  width: 30%;
}
.feedback-section .feedback-card .feedback-table .answer-cell .answer-preview {
  max-height: 3rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.feedback-section .feedback-card .feedback-table .question-read-more {
  display: flex;
  gap: 10px;
  align-items: center;
}
.feedback-section .feedback-card .feedback-table .source-doc-header,
.feedback-section .feedback-card .feedback-table .source-doc-cell {
  width: 12%;
  max-width: 200px;
  min-width: 150px;
}
.feedback-section .feedback-card .feedback-table .source-doc-header .read-more,
.feedback-section .feedback-card .feedback-table .source-doc-cell .read-more {
  color: #3b82f6;
  font-size: 0.85rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.3rem;
  transition: color 0.2s ease;
}
.feedback-section .feedback-card .feedback-table .source-doc-header .read-more i,
.feedback-section .feedback-card .feedback-table .source-doc-cell .read-more i {
  font-size: 0.75rem;
}
.feedback-section .feedback-card .feedback-table .source-doc-header .read-more:hover,
.feedback-section .feedback-card .feedback-table .source-doc-cell .read-more:hover {
  color: #2563eb;
  text-decoration: underline;
}
.feedback-section .feedback-card .feedback-table .tag {
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: center;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.feedback-section .feedback-card .feedback-table .tag i {
  font-size: 0.75rem;
}
.feedback-section .feedback-card .feedback-table .tag.tag-success {
  background: #dcfce7;
  color: #166534;
}
.feedback-section .feedback-card .feedback-table .tag.tag-danger {
  background: #fee2e2;
  color: #991b1b;
}
.feedback-section .feedback-card .feedback-table .no-data {
  text-align: center;
  color: #6b7280;
  padding: 3rem 0;
  font-style: italic;
}
.feedback-section .feedback-card .feedback-table .no-data i {
  font-size: 2.5rem;
  color: #d1d5db;
  margin-bottom: 0.5rem;
  display: block;
}
.feedback-section .feedback-card .feedback-table .no-data p {
  margin: 0.5rem 0 0 0;
}
.feedback-section .feedback-card .feedback-table .email-cell,
.feedback-section .feedback-card .feedback-table .date-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.feedback-section .feedback-card .feedback-table .email-cell i,
.feedback-section .feedback-card .feedback-table .date-cell i {
  color: #9ca3af;
  font-size: 0.85rem;
}
.feedback-section .feedback-card .feedback-table .question-text {
  font-weight: 500;
  color: #374151;
}
.feedback-section .feedback-card .feedback-table .comments-text {
  color: #4b5563;
  word-break: break-word;
}
.feedback-section .feedback-card .feedback-table .source-doc-text {
  color: #4b5563;
  word-break: break-word;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
  transition: color 0.2s ease;
}
.feedback-section .feedback-card .feedback-table .source-doc-text:hover {
  color: #3b82f6;
}
.feedback-section ::ng-deep .p-tooltip {
  max-width: 300px !important;
}
.feedback-section ::ng-deep .p-tooltip .p-tooltip-text {
  white-space: normal !important;
  word-wrap: break-word !important;
  text-align: left !important;
  padding: 8px 12px !important;
  font-size: 13px !important;
}
.feedback-section .pagination-controls {
  display: flex;
  justify-content: end;
  align-items: end;
  gap: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}
.feedback-section .pagination-controls button {
  background: #3b82f6;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.feedback-section .pagination-controls button:hover:not(:disabled) {
  background: #2563eb;
}
.feedback-section .pagination-controls button:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
}
.feedback-section .pagination-controls span {
  color: #374151;
  font-weight: 500;
}
.feedback-section ::ng-deep .p-dialog {
  border-radius: 1rem !important;
}
.feedback-section ::ng-deep .p-dialog .p-dialog-header {
  background: #f9fafb !important;
  color: #111827 !important;
  font-weight: 600;
}
.feedback-section ::ng-deep .p-dialog .answer-dialog-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 1rem;
  line-height: 1.6;
  color: #374151;
  /* Scrollbar inside dialog */
}
.feedback-section ::ng-deep .p-dialog .answer-dialog-content::-webkit-scrollbar {
  width: 6px;
}
.feedback-section ::ng-deep .p-dialog .answer-dialog-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/feedback/feedback.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EAaA,WAAA;EA8DA,UAAA;EAgNA,wBAAA;EAoCA,mBAAA;AA1TF;AAHE;EACE,WAAA;EAEA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAIJ;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;AAEJ;AAAI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAEN;AAAM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAER;AACM;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AACR;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAFN;AAIM;EACE,kBAAA;EACA,UAAA;EACA,cAAA;AAFR;AAKM;EACE,YAAA;EACA,kCAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,gCAAA;AAHR;AAKQ;EACE,qBAAA;EACA,6CAAA;AAHV;AAUE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EAEA,qBAAA;AATJ;AAUI;EACE,UAAA;EACA,WAAA;AARN;AAWI;EACE,mBAAA;EACA,mBAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,uBAAA;AAXN;AAcI;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAZN;AAcM;;EAEE,oBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AAZR;AAeM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAbR;AAeQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAbV;AAeU;EACE,iBAAA;EACA,cAAA;AAbZ;AAkBM;EACE,mBAAA;AAhBR;AAmBM;EACE,UAAA;EACA,gBAAA;AAjBR;AAoBM;EACE,UAAA;AAlBR;AAoBQ;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;AAlBV;AAsBM;EAEE,aAAA;EACA,SAAA;EACA,mBAAA;AArBR;AAwBM;;EAEE,UAAA;EACA,gBAAA;EACA,gBAAA;AAtBR;AAwBQ;;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;AArBV;AAuBU;;EACE,kBAAA;AApBZ;AAuBU;;EACE,cAAA;EACA,0BAAA;AApBZ;AAyBM;EACE,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAvBR;AAyBQ;EACE,kBAAA;AAvBV;AA0BQ;EACE,mBAAA;EACA,cAAA;AAxBV;AA2BQ;EACE,mBAAA;EACA,cAAA;AAzBV;AA6BM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA3BR;AA6BQ;EACE,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;AA3BV;AA8BQ;EACE,oBAAA;AA5BV;AAgCM;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AA9BR;AAgCQ;;EACE,cAAA;EACA,kBAAA;AA7BV;AAiCM;EACE,gBAAA;EACA,cAAA;AA/BR;AAkCM;EACE,cAAA;EACA,sBAAA;AAhCR;AAmCM;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;AAjCR;AAmCQ;EACE,cAAA;AAjCV;AAwCE;EACE,2BAAA;AAtCJ;AAwCI;EACE,8BAAA;EACA,gCAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;AAtCN;AA2CE;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AAzCJ;AA2CI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;AAzCN;AA2CM;EACE,mBAAA;AAzCR;AA4CM;EACE,mBAAA;EACA,mBAAA;AA1CR;AA8CI;EACE,cAAA;EACA,gBAAA;AA5CN;AAiDE;EACE,8BAAA;AA/CJ;AAiDI;EACE,8BAAA;EACA,yBAAA;EACA,gBAAA;AA/CN;AAkDI;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EAEA,4BAAA;AAjDN;AAkDM;EACE,UAAA;AAhDR;AAmDM;EACE,mBAAA;EACA,kBAAA;AAjDR","sourcesContent":[":host {\n  width: 100%;\n}\n\n.feedback-section {\n  padding: 1rem;\n  background: #f8fafc;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n\n  .feedback-container {\n    width: 100%;\n    // max-width: 1200px;\n    background: #ffffff;\n    border-radius: 1rem;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Header */\n  .feedback-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.2rem 1.5rem;\n    border-bottom: 1px solid #e5e7eb;\n    background: #f9fafb;\n\n    .header-content {\n      display: flex;\n      flex-direction: column;\n      gap: 0.3rem;\n\n      .feedback-title {\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: #1f2937;\n        margin: 0;\n      }\n\n      .feedback-subtitle {\n        font-size: 0.875rem;\n        color: #6b7280;\n        margin: 0;\n      }\n    }\n\n    .feedback-title {\n      font-size: 1.5rem;\n      font-weight: 600;\n      color: #1f2937;\n    }\n\n    .search-box {\n      display: flex;\n      align-items: center;\n      position: relative;\n\n      .icon {\n        position: absolute;\n        left: 10px;\n        color: #9ca3af;\n      }\n\n      .search-input {\n        width: 300px;\n        padding: 0.6rem 0.8rem 0.6rem 2rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.5rem;\n        font-size: 0.95rem;\n        outline: none;\n        transition: all 0.2s ease-in-out;\n\n        &:focus {\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);\n        }\n      }\n    }\n  }\n\n  /* Table */\n  .feedback-card {\n    overflow-x: auto;\n    overflow-y: auto;\n    max-height: 70vh;\n    border-radius: 0 0 1rem 1rem;\n\n    /* Custom Scrollbar */\n    &::-webkit-scrollbar {\n      width: 6px;\n      height: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #cbd5e1;\n      border-radius: 10px;\n\n      &:hover {\n        background: #94a3b8;\n      }\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n\n    .feedback-table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: 0.95rem;\n      color: #374151;\n\n      th,\n      td {\n        padding: 0.9rem 1rem;\n        text-align: left;\n        border-bottom: 1px solid #e5e7eb;\n        vertical-align: top;\n      }\n\n      th {\n        background: #f3f4f6;\n        color: #111827;\n        font-weight: 600;\n        position: sticky;\n        top: 0;\n        z-index: 1;\n\n        .th-content {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n\n          i {\n            font-size: 0.9rem;\n            color: #6b7280;\n          }\n        }\n      }\n\n      tr:hover {\n        background: #f9fafb;\n      }\n\n      .question-cell {\n        width: 20%;\n        font-weight: 500;\n      }\n\n      .answer-cell {\n        width: 30%;\n\n        .answer-preview {\n          max-height: 3rem;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n\n      .question-read-more {\n\n        display: flex;\n        gap: 10px;\n        align-items: center;\n      }\n\n      .source-doc-header,\n      .source-doc-cell {\n        width: 12%;\n        max-width: 200px;\n        min-width: 150px;\n\n        .read-more {\n          color: #3b82f6;\n          font-size: 0.85rem;\n          cursor: pointer;\n          display: inline-flex;\n          align-items: center;\n          gap: 0.3rem;\n          margin-top: 0.3rem;\n          transition: color 0.2s ease;\n\n          i {\n            font-size: 0.75rem;\n          }\n\n          &:hover {\n            color: #2563eb;\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .tag {\n        padding: 0.3rem 0.7rem;\n        border-radius: 999px;\n        font-size: 0.8rem;\n        font-weight: 600;\n        text-align: center;\n        display: inline-flex;\n        align-items: center;\n        gap: 0.4rem;\n\n        i {\n          font-size: 0.75rem;\n        }\n\n        &.tag-success {\n          background: #dcfce7;\n          color: #166534;\n        }\n\n        &.tag-danger {\n          background: #fee2e2;\n          color: #991b1b;\n        }\n      }\n\n      .no-data {\n        text-align: center;\n        color: #6b7280;\n        padding: 3rem 0;\n        font-style: italic;\n\n        i {\n          font-size: 2.5rem;\n          color: #d1d5db;\n          margin-bottom: 0.5rem;\n          display: block;\n        }\n\n        p {\n          margin: 0.5rem 0 0 0;\n        }\n      }\n\n      .email-cell,\n      .date-cell {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        i {\n          color: #9ca3af;\n          font-size: 0.85rem;\n        }\n      }\n\n      .question-text {\n        font-weight: 500;\n        color: #374151;\n      }\n\n      .comments-text {\n        color: #4b5563;\n        word-break: break-word;\n      }\n\n      .source-doc-text {\n        color: #4b5563;\n        word-break: break-word;\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        cursor: help;\n        transition: color 0.2s ease;\n\n        &:hover {\n          color: #3b82f6;\n        }\n      }\n    }\n  }\n\n  // Custom tooltip styling for Source Doc (PrimeNG)\n  ::ng-deep .p-tooltip {\n    max-width: 300px !important;\n\n    .p-tooltip-text {\n      white-space: normal !important;\n      word-wrap: break-word !important;\n      text-align: left !important;\n      padding: 8px 12px !important;\n      font-size: 13px !important;\n    }\n  }\n\n  /* Pagination Controls */\n  .pagination-controls {\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    gap: 1rem;\n    padding: 1rem;\n    background: #f9fafb;\n    border-top: 1px solid #e5e7eb;\n\n    button {\n      background: #3b82f6;\n      color: #fff;\n      border: none;\n      padding: 0.5rem 1rem;\n      border-radius: 0.5rem;\n      font-size: 0.9rem;\n      cursor: pointer;\n      transition: all 0.2s ease-in-out;\n\n      &:hover:not(:disabled) {\n        background: #2563eb;\n      }\n\n      &:disabled {\n        background: #cbd5e1;\n        cursor: not-allowed;\n      }\n    }\n\n    span {\n      color: #374151;\n      font-weight: 500;\n    }\n  }\n\n  /* Dialog Content */\n  ::ng-deep .p-dialog {\n    border-radius: 1rem !important;\n\n    .p-dialog-header {\n      background: #f9fafb !important;\n      color: #111827 !important;\n      font-weight: 600;\n    }\n\n    .answer-dialog-content {\n      max-height: 60vh;\n      overflow-y: auto;\n      padding: 1rem;\n      line-height: 1.6;\n      color: #374151;\n\n      /* Scrollbar inside dialog */\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #cbd5e1;\n        border-radius: 8px;\n      }\n    }\n  }\n}\n\n\n\n\n\n\n// .feedback-table-container {\n//     padding: 0;\n//     overflow-x: auto;\n// }\n\n// .feedback-table {\n//     width: 100%;\n//     border-collapse: collapse;\n//     background: #fff;\n\n//     thead {\n//         background: #f4f4f4;\n\n//         th {\n//             padding: 12px 15px;\n//             text-align: left;\n//             font-weight: 600;\n//             border-bottom: 2px solid #e1e1e1;\n//             cursor: pointer;\n//             user-select: none;\n//             position: relative;\n\n\n\n\n\n//             &:hover {\n//                 background: #e8e8e8;\n\n//             }\n//         }\n//     }\n\n//     tbody {\n//         tr {\n//             border-bottom: 1px solid #e1e1e1;\n\n//             &:hover {\n//                 background: #f9f9f9;\n//             }\n\n//             td {\n//                 padding: 12px 15px;\n//                 vertical-align: middle;\n//                 color: #111;\n//                 font-size: 0.875rem;\n//             }\n//         }\n//     }\n// }\n\n// .sortable-header {\n//     .sort-icons {\n//         margin-left: 8px;\n//         display: inline-block;\n\n//         .fa {\n//             font-size: 0.875rem;\n//             color: #888;\n\n//             &.fa-sort {\n//                 opacity: 0.5;\n//             }\n\n//             &.fa-sort-asc,\n//             &.fa-sort-desc {\n//                 color: #3273dc;\n//             }\n//         }\n//     }\n\n\n// }\n\n// .feedback-cell {\n//     position: relative;\n\n//     .feedback-text {\n//         max-width: 400px;\n//         word-wrap: break-word;\n//         white-space: pre-wrap;\n//     }\n// }\n\n// ul.feedback-range {\n//     margin-left: 0px;\n\n//     li {\n//         list-style: none;\n//         display: inline;\n//         margin: 10px;\n//         cursor: pointer;\n//     }\n\n//     .fa {\n//         font-size: 2.5rem !important;\n//     }\n\n//     .fa-smile-o {\n//         color: green;\n//     }\n\n//     .fa-meh-o {\n//         color: orange;\n//     }\n\n//     .fa-frown-o {\n//         color: red;\n//     }\n// }\n\n// textarea {\n//     width: 100%;\n// }\n\n// .help-head-name {\n//     background: #fff;\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
